<template>
    <div>
        <b-row class="point-container" id="point-container" >
            <b-col cols="12" lg="12" id="point-content-imagen">
                <transition :name="clasSlideFade">
                    <img v-if="show" style="animation-duration: .5s" class="points-banner-landing"
                         src="@/assets/images/we/gox3.png" alt="Gox Sign img">
                </transition>
            </b-col>
        </b-row>
    </div>
</template>
<script>

    export default {
        name: 'section-banner',
        components: {
        },
        props: {},
        data: () => ({
            show: true,
            clasSlideFade: 'slide-fade'
        }),
        methods: {
           
        }
    }
</script>